import { Component, ViewChild, AfterViewInit, Input, EventEmitter, Output } from '@angular/core';
import SignaturePad from 'signature_pad';
import { MatButton } from '@angular/material/button';
import { FormControl } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-signature-pad',
    templateUrl: './signature-pad.component.html',
    standalone: true,
    imports: [
        MatButton,
        MatIcon
    ],
    styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements AfterViewInit {
  @Input({required: true }) formCtrl!: FormControl;
  @Output() signApply = new EventEmitter;
  @ViewChild('canvas', { static: true }) signaturePadElement: any;
  private signaturePad?: SignaturePad;
  public isCanvasDisabled = false;

  ngAfterViewInit(): void {
      this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
      if (this.formCtrl.value) {
          this.loadSignature(this.formCtrl.value);
      }
  }

  clearSignature(): void {
      this.signaturePad?.clear();
      this.formCtrl.setValue(null);
      this.isCanvasDisabled = false;
  }
  //сохранение подписи
  saveSignature(): void {
      if (this.signaturePad) {
          const base64Data = this.signaturePad.toDataURL(); // Получение подписи в формате base64
          this.formCtrl.setValue(base64Data);
      }
      this.signApply.emit();
      this.isCanvasDisabled = true; // запрещаем изменять подпись
  }

  // Загрузка сохраненной подписи
  loadSignature(base64Data: string): void {
      if (this.signaturePad instanceof SignaturePad) {
          this.signaturePad.fromDataURL(base64Data).then();
      }
  }
}
